import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map } from 'rxjs/operators';
import { ActionResultCommonBuyerResponse } from '@portal/models/actionResultCommonBuyerResponse';
import type { ActionResultLegalSellerResponse } from '@portal/models/actionResultLegalSellerResponse';
import { CommonBuyerResponse } from '@portal/models/commonBuyerResponse';
import type { LegalBuyerResponse } from '@portal/models/legalBuyerResponse';
import { LegalSellerResponse } from '@portal/models/legalSellerResponse';
import { authClientContext, companiesClientContext, usersClientContext } from '@portal/api-endpoints';
import { getHttpParams, replaceId } from '../../shared/utils';

@Injectable({ providedIn: 'root' })
export class InternalCallbackService {
  private readonly http = inject(HttpClient);

  loadSeller(id: number): Observable<LegalSellerResponse> {
    return this.http
      .get<ActionResultLegalSellerResponse>(replaceId(authClientContext.seller.legalSellerById, id))
      .pipe(map((result: ActionResultLegalSellerResponse) => result.value));
  }

  loadBuyer(id: number): Observable<CommonBuyerResponse | LegalBuyerResponse> {
    return this.http
      .get<ActionResultCommonBuyerResponse>(replaceId(usersClientContext.commonBuyer.getCommonBuyer, id), {
        params: getHttpParams({ includeUser: true }),
      })
      .pipe(
        catchError(_ =>
          this.http.get(replaceId(companiesClientContext.buyer.getById, id), {
            params: getHttpParams({ includeCompany: true }),
          }),
        ),
        map((result: ActionResultCommonBuyerResponse) => result.value),
      );
  }
}
